/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import ccTab from '@/components/common/tab/index.vue';
import contentTable01 from '@/components/common/more-tab-content/content-table-01/index.vue';
export default {
    name: 'page-list',
    components: {ccTab, contentTable01},
    data() {
        return {
            tabList: [
                {
                    name: '域外法治动态',
                    code: 'ywfzdt'
                },
                {
                    name: '域外法律',
                    code: 'ywfl'
                },
                {
                    name: '域外仲裁',
                    code: 'ywzc'
                },
                {
                    name: '域外判决',
                    code: 'ywpj'
                },
                {
                    name: '条约与惯例',
                    code: 'gjgy'
                }
            ],
            active: 'ywfzdt'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'域外法治',
                key:'ywsf',
                path:'/ywsf'
            }];
            const listItem = this.tabList.filter(item => item.code === this.active)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.active = this.$route.query.tab || 'ywfl';
        },
        // 页签切换
        handelTabChange(code) {
            this.active = code;
        }
    }
};
